import { includes as _includes, get as _get } from 'lodash-es';
import { useCallback, useState, useMemo } from 'react';
import { makeStyles } from 'tss-react/mui';
import { eventGalleryQuery } from '../../apollo/events';
import Button from '@mui/material/Button';

import { useQuery } from '@apollo/client/react';
import UploadImagesBox from '../../components/upload-images-box';
import ImageUploadGallery from '../image-upload-gallery';
import SectionHeader from '../section-header';
import type { Event } from '../../types/Event';

const useStyles = makeStyles()((theme) => ({
  loadMorebutton: {
    marginTop: theme.spacing(1),
  },
}));

type Props = {
  event: Event;
  id?: string;
};

const EventImageUploads = ({ event, id }: Props) => {
  const { classes } = useStyles();

  const [uploadOpen, setUploadOpen] = useState(false);
  const [galleryLoaded, setGalleryLoaded] = useState(event.imageUploads && event.imageUploads.length === event.imageUploadsCount);

  const handleToggleUploadOpen = useCallback(() => {
    setUploadOpen(!uploadOpen);
  }, [uploadOpen]);

  const {
    data: galleryData,
    loading: galleryDataLoading,
  } = useQuery(eventGalleryQuery, {
    variables: {
      id: event.id,
    },
    skip: !galleryLoaded,
  });

  const handleLoadGallery = useCallback(() => {
    setGalleryLoaded(true);
  }, []);

  const { membership, imageUploadsCount } = event;
  const hasPermission = membership && _includes(['GOING', 'INTERESTED', 'NOT_GOING'], membership.status);
  const imageUploads = useMemo(() => (
    galleryData ? _get(galleryData, 'event.imageUploads') : event.imageUploads
  ), [event, galleryData]);

  return (
    <div id={id} style={{ marginBottom: 24 }}>
      <SectionHeader>Photos</SectionHeader>

      <ImageUploadGallery
        imageUploads={imageUploads}
        galleryId={event.id}
      />

      {!galleryLoaded && (
        <Button
          onClick={handleLoadGallery}
          variant="outlined"
          className={classes.loadMorebutton}
        >
          {galleryDataLoading ? 'Loading...' : `Load Full Gallery (${imageUploadsCount})`}
        </Button>
      )}

      {uploadOpen ? (
        <UploadImagesBox
          event={event}
          onClose={handleToggleUploadOpen}
        />
      ) : (
        hasPermission && (
          <Button
            onClick={handleToggleUploadOpen}
            variant="contained"
            color="primary"
            sx={{ mt: 1 }}
          >
            Upload Photos
          </Button>
        )
      )}
    </div>
  );
};

export default EventImageUploads;
